<template>
  <div id="app">
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'MyInxaitApp',
  components: {},
  async beforeMount() {
    this.$store.commit('INIT_THEME');
    try {
      if (localStorage.token) {
        await this.session()
          .then((user) => {
            this.SET_lOADING(true)
          })
          .catch((message) => {
            this.SET_lOADING(false)
            this.$router.replace(this.$route.query.redirect || '/')
          })
      } else {
        this.SET_lOADING(false)
        this.$router.replace('/')
      }
    } catch (error) {
    } finally {
      this.SET_lOADING(false)
    }
  },
  methods: {
    ...mapActions(['getList', 'session']),
    ...mapMutations(['SET_lOADING']),
  },
}
</script>

<style lang="sass">
@import 'src/assets/css/main';
</style>



// WEBPACK FOOTER //
// App.vue?70b502dc